import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Conditional class names with later Tailwind utilities winning over earlier
 * ones. Exists so a component can expose a `className` prop that genuinely
 * overrides rather than fighting its own defaults.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
